import CarRightListContainer from "../../../components/car/listing/CarRightList";

const CarRightList = () => {
  return <CarRightListContainer />;
};

export default CarRightList;
